import { Header, Sidebar } from '../../../presentation/components'
import { Container } from '../../../presentation/styles'

import * as S from './styles'

const BaseLayout = ({ children }: any) => {
  return (
    <>
      <Container>
        <Header />
      </Container>
      <Sidebar />
      <S.Content>{children}</S.Content>
    </>
  )
}
export default BaseLayout
